import { navLinks, siteName } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950 text-sm font-heading font-bold">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-sm">
              把放大后的细节、同款、背景与反光都收进同一页，方便逐帧对照。整理在公开素材范围内，标注来源与时间。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.24em] text-background-300 mb-4">
              <a href="#entry" className="hover:text-accent-300 cursor-pointer">
                板块入口
              </a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-background-200 hover:text-background-50 cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] tracking-[0.24em] text-background-300 mb-4">
              <a href="#faq" className="hover:text-accent-300 cursor-pointer">
                内容说明
              </a>
            </h4>
            <p className="text-sm leading-relaxed text-background-200 mb-4">
              页面内容仅供视觉细节参考，不提供原始文件下载，也不鼓励任何形式的追踪行为。如认为内容不妥，可通过常见问题页面联系我们处理。
            </p>
            <a
              href="#faq"
              className="inline-flex items-center gap-1.5 text-sm text-accent-300 hover:text-accent-200 whitespace-nowrap cursor-pointer"
            >
              查看常见问题
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © {year} {siteName} · 视觉细节档案
          </p>
          <p className="text-xs text-background-300">放大 · 细节 · 同款 · 背景 · 反光</p>
        </div>
      </div>
    </footer>
  );
}